const ActionTypes = {
  REST_FAILURE_COUNT: 'REST_FAILURE_COUNT',
};

export default ActionTypes;
